import React, { useEffect, useState } from 'react';
import { billingV2Styles } from '../BillingV2Style';
import { Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CustomSwitch from '../../Common/Switch';
import Select from 'react-select';
import { Alert } from "@material-ui/lab";
import AddBalanceModal from './AddBalanceModal';
import { BILLING_V2_TABS } from '../../../constants/CoreConstants';
import { useDispatch, useSelector } from "react-redux";
import Utils from "../../../helpers/Utils";
import {
    activateCard,
    getInstantTopupSettings,
    getRechargeSettings,
    updateRechargeSettings
} from "../../../api/billingApi";
import useInputField from "../../../hooks/useInputField";
import AddPaymentMethodModal from "./AddPaymentMethodModal";
import NewConfirmAlert from "../../Common/NewConfirmAlert";
import { fetchUserCardInfo } from "../../../actions/billingAction";

const brandColor = '#3e50f7';

const options = [
    // { value: 5, label: '$5' },
    { value: 10, label: '$10' },
    { value: 25, label: '$25' },
    { value: 50, label: '$50' },
    { value: 75, label: '$75' },
    { value: 150, label: '$150' },
    { value: 200, label: '$200' },
    { value: 250, label: '$250' },
    { value: 500, label: '$500' },
    { value: 1000, label: '$1000' },
    { value: 1500, label: '$1500' },
    { value: 2000, label: '$2000' },
    { value: 2500, label: '$2500' },
    { value: 3000, label: '$3000' },
    { value: 3500, label: '$3500' },
    { value: 4000, label: '$4000' },
    { value: 4500, label: '$4500' },
    { value: 5000, label: '$5000' },
    { value: 5500, label: '$5500' },
    { value: 6000, label: '$6000' },
    { value: 6500, label: '$6500' },
    { value: 7000, label: '$7000' },
    { value: 7500, label: '$7500' },
    { value: 8000, label: '$8000' },
    { value: 8500, label: '$8500' },
    { value: 9000, label: '$9000' },
    { value: 9500, label: '$9500' },
    { value: 10000, label: '$10000' }
]

const reactSelectStyle = {
    control: (provided) => ({
        ...provided,
        minHeight: '37px',
        height: '37px',
        display: 'flex',
        alignItems: 'center',      // ensure children are centered
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '37px',
        padding: '0 8px',
        width: "100px",
        display: 'flex',
        alignItems: 'center',      // center the SingleValue/Input
    }),
    singleValue: (provided) => ({
        ...provided,
        lineHeight: '36px',         // match the container height
        margin: 0,                  // reset any default margins
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,                  // no extra top/bottom margin
        padding: 0,                 // let the container’s padding handle spacing
        lineHeight: '37px',         // keep the caret vertically centered
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: '37px',
        display: 'flex',
        alignItems: 'center',      // center the icons
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '8px',             // adjust this as needed
    }),
    clearIndicator: (provided) => ({
        ...provided,
        padding: '8px',
    }),
    option: (provided) => ({
        ...provided,
        padding: '12px 16px',      // taller options
    }),
}

const CreditBalance = ({ setActiveTab }) => {
    const dispatch = useDispatch();
    const [showAddBalanceModal, setShowAddBalanceModal] = useState(false);
    const refillAmountInput = useInputField({
        initialValue: 10,
    });
    const creditReachInput = useInputField({
        initialValue: 10,
    });
    const [refillStatus, setRefillStatus] = useState(false);
    const classes = billingV2Styles();
    const { totalCredits, userCardInfo, isTrial } = useSelector((state) => (state.billingReducer));
    const [saving, setSaving] = useState(false);
    const [showMethodModal, setShowMethodModal] = useState(false);
    const [cardAddedFor, setCardAddedFor] = useState(null);

    useEffect(() => {
        loadData();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const loadData = async () => {
        try {
            const instantResponse = await getInstantTopupSettings({});
            if (instantResponse.data.data !== false) {
                const rechargeResponse = await getRechargeSettings({});
                const result = rechargeResponse.data.data;

                let tmpRefillAmount;
                let tmpCreditReach;
                if (typeof result.refill_amount !== 'undefined') {
                    if (result.refill_amount === "") {
                        tmpRefillAmount = options[0].value;
                        refillAmountInput.setValue(tmpRefillAmount);
                    } else {
                        tmpRefillAmount = result.refill_amount;
                        refillAmountInput.setValue(tmpRefillAmount);
                        setRefillStatus(true);
                    }
                } else {
                    tmpRefillAmount = options[0].value;
                    refillAmountInput.setValue(tmpRefillAmount);
                }

                if (typeof result.credit_reach !== 'undefined') {
                    if (result.credit_reach === "") {
                        tmpCreditReach = options[0].value;
                        creditReachInput.setValue(tmpCreditReach);
                    } else {
                        tmpCreditReach = result.credit_reach;
                        creditReachInput.setValue(tmpCreditReach);
                    }
                } else {
                    tmpCreditReach = options[0].value;
                    creditReachInput.setValue(tmpCreditReach);
                }
            }
        } catch (error) {
            console.error("Failed to load data:", error);
        }
    };

    const submitData = (tmpRefillAmount, tmpCreditReach) => {
        setSaving(true);
        setRefillStatus(true);
        updateRechargeSettings({
            "form_data": {
                refill_amount: (tmpRefillAmount === null ? '' : parseInt(tmpRefillAmount)),
                credit_reach: (tmpCreditReach === null ? '' : parseInt(tmpCreditReach)),
            }
        }).then((response) => {
            if (response.data.status !== 'success') {
                setRefillStatus(false);
            } else {
                window.showNotification("SUCCESS", response.data.message);
            }
        }).finally(() => {
            setSaving(false);
        }).catch((error) => {
            console.log(error);
            setRefillStatus(false);
        })
    }

    const switchOffAutoRecharge = () => {
        setRefillStatus(false);
        updateRechargeSettings({
            "form_data": {}
        }).then((response) => {
            if (response.data.status !== 'success') {
                setRefillStatus(true);
            } else {
                window.showNotification("SUCCESS", response.data.message);
            }
        }).catch((error) => {
            setRefillStatus(true);
        })
    }

    const switchOnAutoRecharge = () => {
        NewConfirmAlert({
            title: 'Confirm to turn on auto recharge',
            description: `Money will be added to your wallet and your card ending in ${userCardInfo?.customer?.card_number} will be charged`,
            cancelText: "Cancel",
            submitText: "Confirm",
            onSubmit: () => {
                submitData(refillAmountInput.value, creditReachInput.value);
            }
        });
    };

    const handleCallback = (data) => {
        if (data.enableAutoRecharge) {
            submitData(refillAmountInput.value, creditReachInput.value);
        }
    };

    const handleAutoRechargeStatus = () => {
        if (refillStatus) {
            switchOffAutoRecharge();
        } else {
            if (userCardInfo?.customer) {
                switchOnAutoRecharge();
            } else {
                setCardAddedFor('auto-recharge');
                setShowMethodModal(true);
            }
        }
    };

    const handleLoadDataCallback = () => {
        dispatch(fetchUserCardInfo({}));
        if (cardAddedFor === 'credit') {
            setShowAddBalanceModal(true);
        } else if (cardAddedFor === 'auto-recharge') {
            switchOnAutoRecharge();
        }
    }

    return (
        <div className={classes.creditBalanceWrapper}>
            <div className='headerSection'>
                <div>
                    <h5 className='title'>Credit Balance</h5>

                    <h2 style={{ margin: "0 0 12px 0", color: "#3e50f7" }}>${Utils.fixDecimal(totalCredits, 2)}</h2>

                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        className="buttonOutlined"
                        disableElevation
                        style={{ width: 150 }}
                        onClick={() => setActiveTab(BILLING_V2_TABS.PAYMENTS)}
                    >
                        View Details
                    </Button>
                </div>

                {!isTrial &&
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="addMoreButton"
                        startIcon={<AddIcon />}
                        disableElevation
                        onClick={() => {
                            if (userCardInfo?.customer) {
                                setShowAddBalanceModal(true);
                            } else {
                                setCardAddedFor('credit');
                                setShowMethodModal(true);
                            }
                        }}
                    >
                        Add More Credits
                    </Button>
                }
            </div>
            {!isTrial &&
                <div className="autoRechargeWrapper">

                    <div className='headerSection'>
                        <h5 className='title'>Auto-Recharge Settings</h5>

                        <div>
                            Auto Recharge is -{" "}
                            <CustomSwitch
                                status={refillStatus}
                                brandColor={brandColor}
                                onChange={handleAutoRechargeStatus}
                            />
                        </div>
                    </div>

                    <div style={{ padding: "16px" }}>
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <div /* style={{ display: "flex", alignItems: "center", gap:12 }} */>
                                    <p style={{ color: "#3a414a" }}>Auto recharge</p>

                                    <Select
                                        options={options}
                                        isClearable={false}
                                        isDisabled={!refillStatus}
                                        value={{
                                            value: refillAmountInput.value,
                                            label: `$${refillAmountInput.value}`,
                                        }}
                                        styles={reactSelectStyle}
                                        onChange={(_selectedOption) => {
                                            refillAmountInput.onChange({
                                                target: {
                                                    value: _selectedOption.value
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={4}>
                                <div /* style={{ display: "flex", alignItems: "center", gap:12 }} */>
                                    <p style={{ color: "#3a414a" }}>When my balance is below</p>

                                    <Select
                                        options={options}
                                        isClearable={false}
                                        isDisabled={!refillStatus}
                                        value={{
                                            value: creditReachInput.value,
                                            label: `$${creditReachInput.value}`,
                                        }}
                                        styles={reactSelectStyle}
                                        onChange={(_selectedOption) => {
                                            creditReachInput.onChange({
                                                target: {
                                                    value: _selectedOption.value
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </Grid>

                            {
                                (refillStatus && (refillAmountInput.isDirty || creditReachInput.isDirty)) &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className="updateAutoRechargeButton"
                                    disableElevation
                                    onClick={() => { submitData(refillAmountInput.value, creditReachInput.value) }}
                                    disabled={saving}
                                >
                                    {saving ? 'Saving...' : 'Save Changes'}
                                </Button>
                            }

                            <Grid item xs={4}>
                                <Alert severity="info" icon={false} className={classes.notesList} style={{ backgroundColor: "#F8F8FF" }}>
                                    <span style={{ fontWeight: 600 }}>
                                        Understanding Auto-Recharge
                                    </span>
                                    <ul style={{ paddingLeft: "10px", margin: "5px" }}>
                                        <li>
                                            Auto-Recharge is designed to prevent you from ever running out of credits
                                        </li>
                                        <li>
                                            If you run out of credits, your campaigns will stop and all sending will be disabled
                                        </li>
                                        <li>
                                            We highly recommend that every user enable this feature
                                        </li>
                                        <li>
                                            Your saved card on file will be used for auto-recharge
                                        </li>
                                        <li>
                                            Select the amount you'd like us to auto-recharge from the drop down menu
                                        </li>
                                        <li>
                                            Select the minimum balance threshold that must be hit before we charge you
                                        </li>
                                        <li>
                                            Once this feature is turned on, you'll never worry about running out of credits again!
                                        </li>
                                    </ul>
                                </Alert>
                            </Grid>
                        </Grid>
                    </div>

                </div>
            }
            {
                showAddBalanceModal && (
                    <AddBalanceModal
                        open={showAddBalanceModal}
                        onModalClose={() => setShowAddBalanceModal(false)}
                        onCallback={handleCallback}
                    />
                )
            }

            {showMethodModal && (
                <AddPaymentMethodModal
                    open={showMethodModal}
                    onClose={() => setShowMethodModal(false)}
                    loadData={handleLoadDataCallback}
                />
            )}
        </div>
    );
};

export default CreditBalance;
